import React, { FC, memo, useCallback, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import Button from '@mui/material/Button'
import { SectionContainer } from 'containers/SectionContainer'
import { InnerContainer } from 'containers/InnerContainer'
import { TitleSection } from 'components/TitleSection'
import { CompareSliderImage } from './CompareSliderImage'

import { staticMultimedia } from 'utils'

import Download from 'assets/images/download.svg'
import Play from 'assets/images/play.svg'

import styles from './styles.module.scss'

interface IProps {
}


const WelcomeSection: FC<IProps> = props => {

  const playNowItem = (title: string, subtitle: string) => (
    <div style={{
      color: '#FFF',
      fontFamily: 'Exo, sans-serif',
      fontSize: '1.25rem',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 'normal',
      textAlign: 'start'
    }}>
      <div>{title}</div>
      <div style={{ fontSize: '0.875rem', fontWeight: 500 }}>{subtitle}</div>
    </div>
  )

  return (
    <SectionContainer id="welcomeToSomniumSpace">
      <InnerContainer style={{ height: '100%', alignItems: 'stretch', borderBottom: '1px solid white' }}>
        <div className={styles.welcomeContainer}>
          <TitleSection title={'Welcome to SOMNIUM SPACE'}
                        subTitle={'where imagination meets innovation in the realm of virtual reality.'}/>
          <div className={styles.compareSliderContainer}>
            <div className={styles.compareSliderWrapperTop}><CompareSliderImage/></div>
            <div className={styles.compareSliderContainerInner}>
              <div className={styles.pcVR}>
                <img src={staticMultimedia.somniumVRLogo} alt="VRLogo"/>
                <div className={styles.description}>
                  Dive into Somnium’s boundless realms through the VR Client. Put on your VR headset and step into a
                  world
                  where creativity knows no bounds. Walk through picturesque landscapes, interact with others in
                  real-time, and be part of a dynamic community that thrives on shared experiences.
                </div>
                <Button
                  onClick={() => {
                    window.open('https://somniumspace.com/launcher/Somnium%20Space.exe', '_self', 'noopener,noreferrer')
                  }}
                  variant="contained"
                  startIcon={
                    <img style={{ width: '21px', height: '21px' }} src={Download} alt="download"/>
                  }
                  size="small"
                  sx={{
                    marginTop: 'auto',
                    background: '#007A99',
                    borderRadius: '7px',
                    color: '#FFFFFF',
                    height: '57px',
                    width: '215px',
                    textTransform: 'capitalize',
                    transition: 'transform .2s',
                    padding: '5px 13px',
                    marginRight: '20px',

                    '&:hover': {
                      background: '#00CCFF'
                    },

                    '&:active': {
                      background: '66E0FF'
                    },

                    '& span': {
                      margin: '0 14px 0 0'
                    }
                  }}
                >
                  {playNowItem('Download', 'Somnium Launcher')}
                </Button>
              </div>
              <div className={styles.compareSliderWrapperMiddle}><CompareSliderImage/></div>
              <div className={styles.web}>
                <img src={staticMultimedia.somniumWebLogo} alt="WebLogo"
                     className={styles.logo}/>
                <div className={styles.description}>
                  The Web Client offers a seamless gateway to the immersive world of Somnium Space. Explore captivating
                  virtual environments, engage with fellow users, and experience creative interactions directly from
                  your mobile phone or any web browser. Immerse yourself with just one click.
                </div>
                <Button
                  onClick={() => {
                    window.open('https://somniumspace.com/parcel/', '_self', 'noopener,noreferrer')
                  }}
                  variant="contained"
                  startIcon={
                    <img style={{ width: '19px', height: '21px' }} src={Play} alt="play"/>
                  }
                  size="small"
                  sx={{
                    marginTop: 'auto',
                    background: '#993D00',
                    borderRadius: '7px',
                    color: '#FFFFFF',
                    height: '57px',
                    width: '215px',
                    textTransform: 'capitalize',
                    transition: 'transform .2s',
                    padding: '5px 13px',

                    '&:hover': {
                      background: '#FF6600'
                    },

                    '&:active': {
                      background: 'FFA366'
                    },

                    '& span': {
                      margin: '0 14px 0 0'
                    }
                  }}
                >
                  {playNowItem('Launch', 'Somnium Web Client')}
                </Button>

              </div>
            </div>
          </div>
        </div>
      </InnerContainer>
    </SectionContainer>
  )
}

export default memo(WelcomeSection)
